import { h } from 'preact'

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Post = props => {
  const { post } = props

  const fullTitle = post.title.rendered.split('&#8211;');
  const title = fullTitle[0];
  const subtitle = fullTitle[1];
  const image = post.featured_image_link;
  const secondImage = post.second_featured_image_link;
  const price = post.price ? post.price : false;
  const url = post.link;
  const thickness = post.product_thickness ? post.product_thickness : false;
  const color = post.product_color ? post.product_color : false;
  const shape = post.product_shape ? post.product_shape : false;
  const reviewRating = post.product_rating ? post.product_rating : 0;
  const reviewComments = post.product_reviews ? post.product_reviews : 0;
  const reviewRatingRounded = post.product_rating !== 0 ? Math.round(post.product_rating) : 0;
  const stars = [];

  console.log(post);

  // Append all the filled whole stars
  for (let i = reviewRatingRounded; i >= 1; i--) {
    stars.push('<svg class="c-icon  c-usps__icon"><use href="#star-full"></use></svg>');
    if (i == .5) stars.push('<svg class="c-icon  c-usps__icon"><use href="#star-half"></use></svg>');
  }

  // Fill the empty stars
  for (let i = (5 - reviewRatingRounded); i >= 1; i--) 
    stars.push('<svg class="c-icon  c-usps__icon"><use href="#star-empty"></use></svg>');

  return (
    <div className={`c-shop-overview__post c-shop-item`}>
      <div className="c-shop-item__image-wrapper">
        <a href={url} className="c-shop-item__image-container u-image">
          <img src={image} className="c-shop-item__image u-image__background" alt={title} />

          {secondImage ? (
            <img src={secondImage} className="c-shop-item__image c-shop-item__image--background u-image__background" alt={title} />
          ) : null}
        </a>
      </div>

      <div className="c-shop-item__header">
        <h3 className="c-shop-item__title">
          <a href={url} className="c-shop-item__product-link">
            {title}
          </a>
        </h3>

        {subtitle ? (
          <div className="c-shop-item__subtitle">
            {subtitle}
          </div>
        ) : null}
      </div>

      <div className="c-shop-item__body u-flex">
        {color ? (
          <div className="c-shop-item__attribute">{color}</div>
        ) : null}

        {thickness ? (
          <div className="c-shop-item__attribute">{thickness} mm</div>
        ) : null}

        {shape ? (
          <div className="c-shop-item__attribute">{shape}</div>
        ) : null}
      </div>

      <div className="c-shop-item__footer u-flex u-flex-sb">
        {post.product_rating !== '0' ? (
          <div className="c-shop-item__rating u-flex">
            <div className="c-shop-item__stars u-flex">
              {stars.map((star) => {
                return (
                  <div className="c-shop-item__star" dangerouslySetInnerHTML={{__html: star}} />
                )  
              })}
            </div>
            
            {reviewComments} reviews
          </div>
        ) : null}
        <div className="c-shop-item__price-container u-flex u-flex-v-center">
          <div className="c-shop-item__price-tag">Vanaf</div>
          <div className="c-shop-item__price">{price}</div>
        </div>
      </div>
    </div>
  )
}

export default Post


// WEBPACK FOOTER //
// ./src/js/shop-overview/components/Post.js